/* eslint-disable max-len */
import * as Sentry from '@sentry/react';

import {
  TREE_TEST_ERROR,
  TREE_TEST_NEXT_QUESTION,
  TREE_TEST_PROJECT_VALUES,
  TREE_TEST_QUESTIONS_ANSWERS,
  TREE_TEST_QUESTIONS_ORDER,
  TREE_TEST_RESET_QUESTIONS,
  TREE_TEST_RESET_SCREENER_ANSWERS,
  TREE_TEST_TEST_SESSION,
} from '../actions/action-types';

export const initialState = {
  answers: [],
  currentQuestion: {},
  error: null,
  isLastQuestion: false,
  isPreview: false,
  loading: false,
  maxTasks: 1,
  project: {},
  questionIndex: 1,
  questions: [],
  testSession: {},
};

const treeTest = (state = initialState, action) => {
  Sentry.setTag('redux.action', action.type);

  switch (action.type) {
    // When the values are returned from the database it is set in the redux for the first time
    case TREE_TEST_QUESTIONS_ORDER: {
      return {
        ...state,
        currentQuestion: action.payload.currentQuestion,
        isLastQuestion: action.payload.questions.length === 1, // If the questions array only have one question the initial value will be true
        maxTasks: action.payload.maxTasks,
        questions: action.payload.questions,
      };
    }

    // Get the next question.
    case TREE_TEST_NEXT_QUESTION: {
      const {
        isLastQuestion,
        currentQuestion,
        questionIndex,
      } = action.payload;

      return {
        ...state,
        currentQuestion,
        isLastQuestion,
        questionIndex,
      };
    }

    case TREE_TEST_RESET_QUESTIONS: {
      return {
        ...initialState,
        testSession: {
          ...state.testSession,
        },
      };
    }

    case TREE_TEST_QUESTIONS_ANSWERS: {
      const { answer } = action.payload;

      return {
        ...state,
        answers: [...state.answers, answer],
      };
    }

    case TREE_TEST_PROJECT_VALUES: {
      return {
        ...state,
        project: action.payload.project,
      };
    }

    case TREE_TEST_TEST_SESSION: {
      const { id } = action.payload.testSession;

      return {
        ...state,
        testSession: { id },
        isPreview: action.payload.isPreview,
      };
    }

    case TREE_TEST_RESET_SCREENER_ANSWERS: {
      return {
        ...state,
        answers: {},
        currentQuestion: {},
        error: null,
        loading: false,
        maxTasks: 1,
        questionIndex: 1,
        questions: [],
      };
    }

    case TREE_TEST_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default treeTest;
